export enum ApplicationStatus {
	All = -1,
	Prospect = 1,
	AppComplete = 17,
	Merged = 25,
}
